


gsap.registerPlugin(ScrollTrigger);

/* -------------------------
   SHOPIFY FIX
-------------------------- */
ScrollTrigger.normalizeScroll(true);
ScrollTrigger.config({
  ignoreMobileResize: true
});

/* -------------------------
   ELEMENTS
-------------------------- */
const images = gsap.utils.toArray(".scroll-img");


// 🔒 HARD INITIAL STATE (runs immediately)
gsap.set(".scroll-img", {
  y: startY(),
  opacity: 1,
  display: "none",
  immediateRender: true
});


/* -------------------------
   MOTION VALUES
-------------------------- */
// motion values
function startY() {
  return window.innerHeight * 0.9;
}

function midY() {
  return 0;
}

function endY() {
  return -window.innerHeight * 0.8;
}


/* -------------------------
   TIMELINE
-------------------------- */
function createScrollTimeline() {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".scroll-gallery",
      start: "top top",
      end: "+=1600",
      scrub: true,
      pin: true,
      pinType: "transform",
      anticipatePin: 1,
      invalidateOnRefresh: true,

      onEnter: () => {
        gsap.set(images, { display: "block" });
      },

      onLeaveBack: () => {
        gsap.set(images, {
          y: startY(),
          opacity: 1, //changed opacity to 1 from 0.
          display: "none"
          
        });
      }
    }
  });

  /* --------------------------------
     PER IMAGE ANIMATION
  -------------------------------- */
  images.forEach((img, i) => {

    const imageTL = gsap.timeline();

    imageTL
      // enter from bottom
      .fromTo(
        img,
        { y: startY(), opacity: 1 },
        { y: midY(), opacity: 1, ease: "none" }
      )

      // move up and disappear
      .to(
        img,
        { y: endY()+(-500), opacity: 1, ease: "none" } //changed opacity to 1 from 0 and added -200
      );

    // stagger each image's full lifecycle
    tl.add(imageTL, i * 0.8);
  });

  return tl;
}

let scrollTimeline = createScrollTimeline();


window.addEventListener("resize", () => {
  ScrollTrigger.refresh();
});

